import { motion, AnimatePresence } from "framer-motion";
import { IoMdClose } from "react-icons/io";

export default function ContactModal({ isOpen, onClose,phone }) {



    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
                    onClick={onClose}
                >
                    <motion.div
                        initial={{ scale: 0.9, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.9, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className="bg-white rounded-2xl shadow-lg w-full max-w-md sm:max-w-md md:max-w-md lg:max-w-xl p-4 pb-8 sm:p-6 md:p-8 md:pb-10 relative mx-3"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* دکمه بستن */}
                        <div className="flex justify-end items-center">
                            <button
                                onClick={onClose}
                                className="flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 text-special rounded-lg hover:scale-105 transition-transform"
                            >
                                <IoMdClose size={22} />
                            </button>
                        </div>

                        {/* محتوای مودال */}
                        <div className="mt-4 sm:mt-6 md:mt-8">
                            <div className="flex pr-5 justify-start items-center mb-6 sm:mb-8">
                                <h2 className="text-base sm:text-lg md:text-xl font-bold text-gray-800 text-center">
                                    اطلاعات تماس آگهی دهنده
                                </h2>
                            </div>

                            <div className="flex divide-y-[1px] divide-gray-300 flex-col gap-3 text-sm text-gray-700">
                                {/* <div className="flex flex-row justify-between pt-3 sm:pt-4 items-center w-full">
                                    <span className="text-sm sm:text-base text-gray-800 font-medium break-words">
                                        نام و نام خانوادگی:
                                    </span>
                                    <span className="text-xs sm:text-sm text-gray-500">{name}</span>
                                </div> */}

                                <div className="flex flex-row justify-between pt-3 sm:pt-4 items-center w-full">
                                    <span className="text-sm sm:text-base text-gray-800 font-medium break-words">
                                        شماره تماس:
                                    </span>
                                    <span className="text-xs sm:text-sm text-gray-500">{phone}</span>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
